import React from 'react';
import { InputField } from 'components/Global';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const DetailDeposit = ({ isVendorOrder, customerAccountBank }) => {
  const isB2BPartnerIntegrationEnabled = useFliptBoolean('ENABLE_B2B_PARTNER_INTEGRATION', false, 'anonymous');

  return (
    <div className="detail-order-with-driver__deposit-detail">
      <div className="detail-order-with-driver__deposit-detail-title">
        <h1>Detail Deposit</h1>
      </div>
      <div className="detail-order-with-driver__deposit-detail-body">
        <InputField
          label="Nama Akun"
          disabled
          value={isB2BPartnerIntegrationEnabled && isVendorOrder ? '-' : customerAccountBank.nama_rek || '-'}
        />
        <InputField
          label="No Rekening"
          disabled
          value={isB2BPartnerIntegrationEnabled && isVendorOrder ? '-' : customerAccountBank.no_rek || '-'}
        />
        <InputField
          label="Nama Bank"
          disabled
          value={isB2BPartnerIntegrationEnabled && isVendorOrder ? '-' : customerAccountBank.nama_bank || '-'}
        />
      </div>
    </div>
  );
};

export default DetailDeposit;
